import type { SxProps, Theme } from '@mui/material/styles'

import { borderRadius, spacing } from '../../KestrixDesignSystem.jsx'

/** CSS transitions for metric card chrome (loading → loaded, hover). */
export const METRIC_CARD_SHELL_TRANSITION =
  'background-color 0.2s ease, border-color 0.2s ease'

/**
 * Shared layout + chrome animation for KestrixMetricCard and KestrixMetricCardSkeleton.
 * Does not include background/border colours — merge those per state.
 *
 * Compact "metric tile" shape: title row + value/delta row, no min-height padding.
 */
export const metricCardShellLayoutSx = {
  display: 'flex',
  flex: '1 1 0',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: spacing[1],
  px: spacing[4],
  py: spacing[3],
  borderRadius: borderRadius.md,
  borderWidth: 1,
  borderStyle: 'solid',
  width: '100%',
  minWidth: 0,
  maxWidth: 350,
  boxSizing: 'border-box',
  transition: METRIC_CARD_SHELL_TRANSITION
} as const satisfies SxProps<Theme>
